import React, { Component } from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Editproductcontent from '../sections/Addproduct/Editproductcontent'
import Quickbar from '../layouts/Quickbar';

class Editproduct extends Component {
    render() {
        return (
            <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
                <Sidenavigation />
                <main className="body-content">
                    <Topnavigation />
                    <Editproductcontent/>
                </main>
                <Quickbar />
            </div>
        );
    }
}

export default Editproduct;